// extracted by mini-css-extract-plugin
export default {"mainContainer":"ReportingDeadlinesTableArea_mainContainer__VEbhN","topCaptionContainer":"ReportingDeadlinesTableArea_topCaptionContainer__mT4OF"};